@let isSelfProfile = isSelfProfile$ | async;

<div class="general-profile-page" [class.general-profile-page--edit]="isEditMode">

    <div class="general-profile-page-anchor" inViewport
        (inViewportAction)="onToolbarMinimizerAnchorViewportChange($event)">
    </div>

    <div class="general-profile-page-toolbar" [class.general-profile-page-toolbar--edit]="isEditMode"
        [class.general-profile-page-toolbar--minimized]="isMinimizedToolbar">

        @if (isEditMode) {
        <rpc-button class="general-profile-page-toolbar-left" [text]="'GENERAL_INFO_PAGE.TITLES.CANCEL'"
            (clicked)="onCancel()">
        </rpc-button>
        } @else {
        <rpc-button class="general-profile-page-toolbar-left" [title]="'GENERAL_INFO_PAGE.TITLES.BACK'"
            [iconName]="'left'" [iconSquareButton]="true" (clicked)="onNavigateBack()">
        </rpc-button>
        }

        <div class="general-profile-page-toolbar-title rpc-title-font"
            [title]="'GENERAL_INFO_PAGE.TITLES.GENERAL' | translate">
            {{ 'GENERAL_INFO_PAGE.TITLES.GENERAL' | translate }}
        </div>

        @if (isEditMode) {
        <rpc-button class="general-profile-page-toolbar-right" [color]="'accent'"
            [text]="'GENERAL_INFO_PAGE.TITLES.SAVE'" (clicked)="onSave()">
        </rpc-button>
        } @else {
        <rpc-button class="general-profile-page-toolbar-right" [iconName]="'edit'"
            [title]="'GENERAL_INFO_PAGE.TITLES.EDIT'" [iconSquareButton]="true" (clicked)="onEdit()">
        </rpc-button>
        }

    </div>

    @let isPrimaryCustomer = isPrimaryCustomer$ | async;
    @let emails = emails$ | async;
    @let phones = phones$ | async;
    @let addresses = addresses$ | async;

    @if (isEditMode) {
    <general-info-form class="general-profile-page-body" [isPrimaryCustomer]="isPrimaryCustomer"
        [isSelfProfile]="isSelfProfile" [emails]="emails" [phones]="phones" [addresses]="addresses"
        [isFullVersion]="false">
    </general-info-form>
    } @else {
    <general-info class="general-profile-page-body" [isPrimaryCustomer]="isPrimaryCustomer"
        [isSelfProfile]="isSelfProfile" [emails]="emails" [phones]="phones" [addresses]="addresses"
        [isFullVersion]="false">
    </general-info>
    }

    <rpc-scroll-to-top class="rpc-scroll-to-top-wrap">
    </rpc-scroll-to-top>

</div>